/* unplugin-vue-components disabled */import { render } from "./KilaKilaButton.vue?vue&type=template&id=574cba32&scoped=true"
import script from "./KilaKilaButton.vue?vue&type=script&lang=js"
export * from "./KilaKilaButton.vue?vue&type=script&lang=js"

import "./KilaKilaButton.vue?vue&type=style&index=0&id=574cba32&scoped=true&lang=css"

import exportComponent from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574cba32"]])

export default __exports__